// Global state to track the currently open dropdown across all node shapes
let globalOpenDropdownId = null;
let globalDropdownListeners = new Set();

/**
 * Notifies all subscribed components that the global dropdown state has changed.
 */
const notifyDropdownChange = () => {
  globalDropdownListeners.forEach(listener => listener());
};

/**
 * Opens a specific dropdown and closes any others.
 * @param {string|number} id The unique ID of the node/dropdown to open
 */
export const openGlobalDropdown = (id) => {
  if (globalOpenDropdownId && globalOpenDropdownId !== id) {
    globalOpenDropdownId = null;
    notifyDropdownChange();
  }

  globalOpenDropdownId = id;
  notifyDropdownChange();
};

/**
 * Closes a specific dropdown if it is currently open.
 * @param {string|number} id The unique ID of the node/dropdown to close
 */
export const closeGlobalDropdown = (id) => {
  if (globalOpenDropdownId === id) {
    globalOpenDropdownId = null;
    notifyDropdownChange();
  }
};

/**
 * Closes whichever dropdown is currently open, if any.
 */
export const closeAllDropdowns = () => {
  if (globalOpenDropdownId !== null) {
    globalOpenDropdownId = null;
    notifyDropdownChange();
  }
};

/**
 * Checks if a specific dropdown is open.
 * @param {string|number} id The unique ID to check
 * @returns {boolean}
 */
export const isGlobalDropdownOpen = (id) => {
  return globalOpenDropdownId === id;
};

/**
 * Subscribes a component to dropdown state changes.
 * @param {Function} listener Callback to execute on change
 * @returns {Function} Unsubscribe function
 */
export const subscribeToDropdownChanges = (listener) => {
  globalDropdownListeners.add(listener);
  return () => {
    globalDropdownListeners.delete(listener);
  };
};
